import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage2 from "../HomePage2/HomePage2";
import Header2 from "../../components/Header2/Header2";
import AboutUsPage from "../AboutUsPage/AboutUsPage";
import PricingPage from "../PricingPage/PricingPage";
import PortfolioPage from "../PortfolioPage/PortfolioPage";
import PortfolioSinglePage from "../PortfolioSinglePage/PortfolioSinglePage";
import TeamPage from "../TeamPage/TeamPage";
import TeamSinglePage from "../TeamSinglePage/TeamSinglePage";
import ServicePage from "../ServicePage/ServicePage";
import ServicesSinglePage from "../../components/software-company-components/ServicesSinglePage/ServicesSinglePage";
import ContactPage from "../ContactPage/ContactPage";
import Footer from "../../components/software-company-components/Footer/Footer";
import FaqsPage from "../FaqsPage/FaqsPage";

import CareerPage from "../CareerPage/CareerPage";
import SeoDetailPage from "../CareerPage/SeoDetailPage";
import GraphicDetailPage from "../CareerPage/GraphicDetailPage";
import BdDetailPage from "../CareerPage/BdDetailPage";

import Privacypolicy from "../PrivacyPolicy/Privacypolicy";
import TermsCondition from "../Terms&conditions/TermsConditions";
import Pagenotfound from "../Pagenotfound/Pagenotfound";
const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Header2 />
        <Routes>
          <Route path="/" element={<HomePage2 />} />
          <Route path="/about" element={<AboutUsPage />} />
          {/* <Route path="/pricing" element={<PricingPage />} /> */}
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/case_study/:slug" element={<PortfolioSinglePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/team-single/:slug" element={<TeamSinglePage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/services/:slug" element={<ServicesSinglePage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="/faqs" element={<FaqsPage />} />

          <Route path="/career" element={<CareerPage />} />
          <Route path="/seo-detail" element={<SeoDetailPage />} />
          <Route path="/graphic-detail" element={<GraphicDetailPage />} />
          <Route path="/bd-detail" element={<BdDetailPage />} />

          <Route path="/privacypolicy" element={<Privacypolicy />} />
          <Route path="/termsconditions" element={<TermsCondition />} />
          <Route path="*" element={<Pagenotfound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
